import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FaTimes } from 'react-icons/fa'

const NotificationBanner = () => {
  const [isVisible, setIsVisible] = useState(true)

  if (!isVisible) return null

  return (
    <div className='bg-secondary text-text-primary py-2 px-4'>
      <div className='container mx-auto flex items-center justify-between'>
        <div className='flex-1 text-center'>
          <span className='text-sm'>
            Lanzamos nuestra API 🎉 - Ahora puedes integrar directamente códigos IAE/CNAE en tu aplicación.{' '}
          </span>
          <a
                  href='https://api.conversoriaecnae.es'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-sm italic text-white underline hover:text-surface'
                >
                  Pruébala gratis
                </a>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className='ml-4 text-text-primary hover:text-primary'
          aria-label='Cerrar notificación'
        >
          <FaTimes />
        </button>
      </div>
    </div>
  )
}

export default NotificationBanner
